import Moment from "react-moment";
import React from "react";

function DateTimeCell({ value }: any) {
  if (value === null) return "Not Logged in";
  return <Moment date={value} format={"HH:mm:ss DD/MM/YYYY"} />;
}

export default DateTimeCell;
